import React from 'react'
import './styles/badge.scss'
import HoverInfo from './HoverInfo'

const Badge = (props) => {
    const {
        children, cssClass, isRounded, type, style, label, icon, onClick, hoverInfo,
    } = props

    let componentClass = 'uc-badge'
    componentClass += isRounded ? ' rounded' : ''
    componentClass += icon ? ' iconBadge' : ''
    componentClass += type ? ` ${type}` : ''
    componentClass += cssClass ? ` ${cssClass}` : ''
    componentClass += onClick ? ' link' : ''

    return (
        <span className={componentClass} style={style} onClick={onClick}>
            {label}
            {icon ? <i className={icon} /> : null}
            {hoverInfo ? (
                <HoverInfo
                    cssClass="hover-info"
                    desc={hoverInfo.desc || 'nope'}
                    dir={hoverInfo.dir}
                >
                    <i className="info-icon fa-solid fa-circle-question" style={{ fontSize: 14 }} />
                </HoverInfo>
            ) : null}
            {children}
        </span>
    )
}

export default Badge
